export const seoKeywords = {
  name: 'keywords',
  content:
    'ZK proof, ZKP, ZKP development, zero knowledge proof development, snark development, stark development',
};

export const zeroKnowledgeProofDevelopmentSeo = {
  title: 'Zero-Knowledge Proof Development Services with Rumble Fish',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        "Zero-knowledge proof development with Rumble Fish. While others are still talking about possibilities, we're shipping production-ready zero-knowledge solutions that solve real problems for real businesses.",
    },
  ],
};
